import { useEffect, useState, useRef } from 'react';
import api from '@/data/api';
import { useLocation, useParams } from 'react-router-dom';
import TRCHorizontalScrollComponent from '@/TRC/components/horizontalDivComponent';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const getRouteForItem = item => {
	if (item.model === 'Video' || item.vimeoId) return TRC_ROUTES.VIDEOS;
	if (item.model === 'LessonPlan') return TRC_ROUTES.PROGRESSIVE_LESSON_PLANS;
	if (item.model === 'TRCContent' || item.fileType) return TRC_ROUTES.RESOURCES;
	return TRC_ROUTES.RESOURCES;
};

const getBasePathForItem = (item, pathname) => {
	if (item.model === 'LessonPlan') {
		if (pathname.startsWith(TRC_ROUTES.STUDIO_HUB_HOME)) {
			return `${TRC_ROUTES.STUDIO_HUB_HOME.slice(1)}/${TRC_ROUTES.PROGRESSIVE_LESSON_PLANS}`;
		}
		if (pathname.startsWith(TRC_ROUTES.TRC_HOME)) {
			return `${TRC_ROUTES.TRC_HOME.slice(1)}/${TRC_ROUTES.PROGRESSIVE_LESSON_PLANS}`;
		}
		return 'lesson-plan';
	}
	return undefined;
};

const normalizeRelatedItem = item => ({
	...item,
	thumbnailLink: item.thumbnailLink || item.thumnailLink,
	thumnailLink: item.thumnailLink || item.thumbnailLink
});

const Related = ({ content }) => {
	const { id } = useParams();
	const { pathname } = useLocation();
	const [contents, setContents] = useState();
	const scrollRef = useRef(null);
	const [canScrollLeft, setCanScrollLeft] = useState(false);
	const [canScrollRight, setCanScrollRight] = useState(true);

	useEffect(() => {
		if (content?.related?.length) {
			setContents(content.related.map(r => {
				const item = normalizeRelatedItem(r.referralData || r);
				if (item.model === 'LessonPlan') {
					return { ...item, fileType: 'pdf', isStudioLessonPlan: true };
				}
				return item;
			}));
			return;
		}
		const fetchRelated = async () => {
			const response = await api.getRelated(id);
			setContents((response.data || []).map(normalizeRelatedItem));
		};
		fetchRelated();
	}, [id, content]);

	const checkScroll = () => {
		const el = scrollRef.current;
		if (!el) return;
		setCanScrollLeft(el.scrollLeft > 0);
		setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
	};

	useEffect(() => {
		checkScroll();
	}, [contents]);

	const scroll = (direction) => {
		const el = scrollRef.current;
		if (!el) return;
		const scrollAmount = 300;
		el.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
	};

	if (!contents?.length) return null;

	return (
		<div className="slide_arrow_container">
			{canScrollLeft && (
				<div className="left_arrow" onClick={() => scroll('left')}>
					<ArrowBackIosIcon style={{ fontSize: '30px', color: '#097dac' }} />
				</div>
			)}
			{canScrollLeft && <div className="fade-left" />}
			<div className="d-flex overflow-auto" ref={scrollRef} onScroll={checkScroll} style={{ gap: '16px' }}>
				{contents.map(item => (
					<TRCHorizontalScrollComponent
						key={item._id || item.referralId}
						contents={[item]}
						route={getRouteForItem(item)}
						basePath={getBasePathForItem(item, pathname)}
						showButton={false}
						cardMaxWidth="352px"
						className="related-content-section"
					/>
				))}
			</div>
			{canScrollRight && (
				<div className="right_arrow" onClick={() => scroll('right')}>
					<ArrowForwardIosIcon style={{ fontSize: '30px', color: '#097dac' }} />
				</div>
			)}
			{canScrollRight && <div className="fade-right" />}
		</div>
	);
};

export default Related;
